import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import * as CentroCostoService from 'services/centrosCosto.service'

import { KeyEventUtil } from 'utils'

const CentroCostoFormGroup = ({
  iError,
  iTouched,
  fIsSubmitting,
  handleChange,
  setFieldValue,
  nextNodeId
}) => {
  const [centrosCosto, setCentrosCosto] = React.useState([])

  React.useEffect(() => {
    CentroCostoService.getSelect()
      .then(({ data }) => {
        setCentrosCosto(data)
      })
      .catch(() => setCentrosCosto([]))
  }, [])

  const onChange = React.useCallback(
    e => {
      handleChange(e)
      const matchedCentro = centrosCosto.find(x => x._id === e.target.value)
      if (matchedCentro) {
        setFieldValue('centroCostoInfo', `${matchedCentro.codigo} - ${matchedCentro.descripcion}`)
      } else {
        setFieldValue('centroCostoInfo', '')
      }
    },
    [handleChange, setFieldValue, centrosCosto]
  )

  const onKeyDown = React.useCallback(
    e => {
      KeyEventUtil.leaveOnEnterOrTab(nextNodeId, e)
    },
    [nextNodeId]
  )

  return (
    <Form.Group>
      <Form.Label text='CENTRO COSTO' htmlFor='select-modalavanz-centrocosto' md={12} />
      <Col md={12}>
        <Field name='_idCentroCosto'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-modalavanz-centrocosto'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onChange={onChange}
              onKeyDown={onKeyDown}
            >
              <option value=''>Seleccionar</option>
              {centrosCosto.map((x, k) => (
                <option key={k} value={x._id}>{`${x.codigo} - ${x.descripcion}`}</option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CentroCostoFormGroup)
